import { useCallback, useLayoutEffect, useRef } from "react";

export function useEvent<T>(handler: T): T {
  const handlerRef = useRef<any>(null);

  useLayoutEffect(() => {
    handlerRef.current = handler;
  });

  return useCallback((...args: any[]) => {
    return handlerRef.current(...args);
  }, []) as any;
}
